import client from "./client";

export default {
    async sendMessage(data){
        return client.parseResponse(await client.post('/contact', data))
    },
}
